import {findGlobalLock} from './globalLocks';

/*
 * Lock keys.
 */

export const preferencesLockKey = 'user/preferences';
export const accessLockKey = 'user/access';
export const workspaceLockKey = 'user/workspace';

function createBuildResourceLockKey<TId>(prefix: string) {
  return (id: TId) => `${prefix}/${id}`;
}

export const buildCardLockKey = createBuildResourceLockKey<number>('cards');
export const buildCardNoteLockKey = createBuildResourceLockKey<number>('cardNotes');
export const buildAccountsLockKey = createBuildResourceLockKey<number>('accounts');
export const buildConversationLockKey = createBuildResourceLockKey<number>('conversations');
export const buildTeammateLockKey = createBuildResourceLockKey<number>('teammate');
export const buildMessageLockKey = createBuildResourceLockKey<string>('messages');
export const buildCommentLockKey = createBuildResourceLockKey<string>('comments');
export const buildActivityLockKey = createBuildResourceLockKey<number>('activities');
export const buildTagLockKey = createBuildResourceLockKey<number>('tags');
export const buildCalendarLockKey = createBuildResourceLockKey<number>('calendars');
export const buildCalendarVersionLockKey = createBuildResourceLockKey<number>('calendarVersions');
export const buildCalendarEventLockKey = createBuildResourceLockKey<string>('calendarEvents');
export const buildCalendarEventVersionLockKey = createBuildResourceLockKey<string>('calendarEventVersions');
export const buildSchedulingLinkLockKey = createBuildResourceLockKey<number>('schedulingLinks');
export const buildAnswerLockKey = createBuildResourceLockKey<number>('answers');
export const buildAnswerFolderLockKey = createBuildResourceLockKey<number>('answerFolders');
export const buildVacationResponderLockKey = createBuildResourceLockKey<number>('vacationResponders');

/*
 * Locks.
 */

export const preferencesLock = findGlobalLock(preferencesLockKey);
export const accessLock = findGlobalLock(accessLockKey);
export const workspaceLock = findGlobalLock(workspaceLockKey);

function createFindResourceLock<TId>(buildLockName: (id: TId) => string) {
  return (id: TId) => findGlobalLock(buildLockName(id));
}

export const findCardLock = createFindResourceLock(buildCardLockKey);
export const findCardNoteLock = createFindResourceLock(buildCardNoteLockKey);
export const findAccountLock = createFindResourceLock(buildAccountsLockKey);
export const findConversationLock = createFindResourceLock(buildConversationLockKey);
export const findTeammateLock = createFindResourceLock(buildTeammateLockKey);
export const findMessageLock = createFindResourceLock(buildMessageLockKey);
export const findCommentLock = createFindResourceLock(buildCommentLockKey);
export const findActivityLock = createFindResourceLock(buildActivityLockKey);
export const findTagLock = createFindResourceLock(buildTagLockKey);
export const findCalendarLock = createFindResourceLock(buildCalendarLockKey);
export const findCalendarVersionLock = createFindResourceLock(buildCalendarVersionLockKey);
export const findCalendarEventLock = createFindResourceLock(buildCalendarEventLockKey);
export const findCalendarEventVersionLock = createFindResourceLock(buildCalendarEventVersionLockKey);
export const findSchedulingLinkLock = createFindResourceLock(buildSchedulingLinkLockKey);
export const findAnswerLock = createFindResourceLock(buildAnswerLockKey);
export const findAnswerFolderLock = createFindResourceLock(buildAnswerFolderLockKey);
